var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"poMap"},[_c('div',{staticClass:"politicalMiningMap",attrs:{"id":"politicalMiningMap"}}),_c('div',{staticClass:"change-batch",on:{"click":_vm.changeBatch}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"batch"},[_c('img',{attrs:{"src":require("@/assets/images/homePage_images/peopleImg.png"),"alt":""}}),_c('div',[_vm._v("换一批长者")])])
}]

export { render, staticRenderFns }